import type { ReactNode } from 'react'

import { cn } from '@/legacy-src/lib/utils'

export interface TherapistFilterMenuGroupUIProps {
  children: ReactNode
  className?: string
}

export function TherapistFilterMenuGroupUI({ children, className }: TherapistFilterMenuGroupUIProps) {
  return (
    <div role="group" className={cn('flex flex-col gap-6', className)}>
      {children}
    </div>
  )
}
